import { Fade, Grid, Slide, Typography } from '@mui/material';
import { LayoutCard } from '../Layout/LayoutCard';
import logo from '../imgs/logo.png';

const HomePage: React.FC = () => {
    return (
        <LayoutCard>
            <Grid
                container
                style={{
                    height: '100%',
                    paddingBottom: '50px',
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <Grid
                    item
                    xs={8}
                    md={6}
                    xl={3}
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Fade in={true} timeout={1000}>
                        <img
                            src={logo}
                            alt="logo"
                            style={{ width: '100%', height: '100%' }}
                        />
                    </Fade>
                </Grid>{' '}
                <Grid
                    item
                    xs={12}
                    style={{
                        display: 'flex',
                        alignItems: 'flex-end',
                        justifyContent: 'center',
                    }}
                >
                    <Slide in={true} timeout={1000} direction="up">
                        <Typography variant="h2" style={{ fontWeight: 'bold' }}>
                            YOGA
                        </Typography>
                    </Slide>
                </Grid>
                <Grid
                    item
                    xs={12}
                    style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'center',
                    }}
                >
                    <Slide in={true} timeout={1000} direction="down">
                        <Typography variant="h2" sx={{ fontWeight: 'bold' }}>
                            HARMONY
                        </Typography>
                    </Slide>
                </Grid>
                <Grid
                    item
                    xs={10}
                    style={{
                        display: 'flex',
                        alignItems: 'flex-end',
                        justifyContent: 'center',
                    }}
                >
                    <Fade in={true} timeout={1000}>
                        <div
                            style={{
                                textAlign: 'center',
                                padding: '20px',
                                borderRadius: '10px',
                            }}
                        >
                            <Typography variant="subtitle1">
                                Chcete-li si se mnou posílit a zároveň
                                protáhnout tělo na vlně harmonické jógy,
                                kontaktujte mě.
                            </Typography>
                            <Typography
                                variant="subtitle1"
                                style={{ fontWeight: 'bold' }}
                            >
                                tana@yogaharmony.cz
                            </Typography>
                            <Typography variant="subtitle1">
                                Těším se na setkání s Vámi!
                            </Typography>
                            <Typography variant="subtitle1">Táňa</Typography>
                        </div>
                    </Fade>
                </Grid>
            </Grid>
        </LayoutCard>
    );
};

export default HomePage;
